export const LIST_LOAD = 'LIST_LOAD';
export const LIST_LOADED = 'LIST_LOADED';
export const LIST_UNLOADED = 'LIST_UNLOADED';
export const LIST_RELOAD = 'LIST_RELOAD';
